import React from "react";

function Optoma() {
    return(
        <h1>This si the optoma page</h1>
    );
}

export default Optoma